import { Button, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import Movie from 'redux/models/movie'
import { MoviesState } from 'redux/modules/movies'
import { Modal } from './styles'

type VerificationModalProps = {
  item: Movie
  movies: MoviesState
  onVerify: (isValid: boolean) => void
  onCancel: () => void
  onClose: () => void
}

const VerificationModal = (props: VerificationModalProps) => {
  const { item, movies, onVerify, onCancel, onClose } = props
  const { item: verificationItem, verifing, verificationError, canceling, cancelError } = movies.verification

  return (
    <Modal aria-labelledby="simple-modal-title" open onClose={onClose}>
      <Paper sx={{ p: 4, overflow: 'scroll' }}>
        <Grid
          container
          direction="column"
          spacing={3}
          sx={{
            alignItems: 'center',
          }}>
          <Grid>
            <Typography variant="h4" id="simple-modal-title">
              {item.word}
            </Typography>
          </Grid>
          <Grid>
            <video
              width={Math.min(window.screen.width * 0.7, 500)}
              height={Math.min(window.screen.height * 0.5, 500)}
              src={item.fileURL}
              controls
            />
          </Grid>
          <Grid>
            <a href={item.browserURL} target="blank">
              Google Drive で動画を見る
            </a>
          </Grid>
          {(!verificationItem || verifing) && (
            <Grid
              container
              spacing={3}
              sx={{
                justifyContent: 'center',
              }}>
              <Grid>
                <Button
                  variant="outlined"
                  component="label"
                  color="secondary"
                  disabled={verifing}
                  onClick={() => onVerify(false)}>
                  無効にする
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="outlined"
                  component="label"
                  color="primary"
                  disabled={verifing}
                  onClick={() => onVerify(true)}>
                  有効にする
                </Button>
              </Grid>
            </Grid>
          )}
          {verificationItem && !verifing && !verificationError && (
            <Grid
              container
              spacing={3}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Grid>
                <Typography sx={(theme) => ({ color: theme.palette.success.main })}>検証完了!</Typography>
              </Grid>
              <Grid>
                <Button variant="outlined" component="label" color="secondary" disabled={canceling} onClick={onCancel}>
                  検証を取り消す
                </Button>
              </Grid>
            </Grid>
          )}
          {verificationError && (
            <Grid>
              <Typography color="secondary">反映に失敗しました</Typography>
            </Grid>
          )}
          {cancelError && (
            <Grid>
              <Typography color="secondary">検証の取り消しに失敗しました</Typography>
            </Grid>
          )}
          <Grid>
            <Button variant="outlined" component="label" onClick={onClose}>
              閉じる
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  )
}

export default VerificationModal
